module.exports = __webpack_public_path__ + "static/img/Rectangle25.bfb1cc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Rectangle25.png
// module id = P6Fg
// module chunks = 1